export default {
  name: 'Tooltip',
  props: {
    text: {
      type: [String, Number],
      default: '',
      required: true
    },
    position: {
      type: String,
      default: 'top',
      validator (value) {
        const positions = [
          'top',
          'bottom',
          'left',
          'right',
          'top-left',
          'top-right',
          'bottom-left',
          'bottom-right'
        ]
        return positions.indexOf(value) !== -1
      }
    },
    showDelay: {
      type: String,
      default: '1s'
    },
    hideDelay: {
      type: String,
      default: '0s'
    },
    multiline: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tooltip: undefined
    }
  },
  computed: {
    getClasses () {
      return {
        'tooltip': true,
        'top': this.position === 'top',
        'top-left': this.position === 'top-left',
        'top-right': this.position === 'top-right',
        'bottom': this.position === 'bottom',
        'bottom-left': this.position === 'bottom-left',
        'bottom-right': this.position === 'bottom-right',
        'left': this.position === 'left',
        'right': this.position === 'right',
        'multiline': this.multiline
      }
    }
  },
  methods: {
    show () {
      this.tooltip.style.transitionDelay = this.showDelay
      this.tooltip.classList.add('visible')
    },

    hide () {
      this.tooltip.style.transitionDelay = this.hideDelay
      this.tooltip.classList.remove('visible')
    }
  },
  mounted () {
    if (this.text !== '') {
      this.tooltip = this.$el.querySelector('.tooltip')
      this.$el.addEventListener('mouseover', this.show, false)
      this.$el.addEventListener('mouseout', this.hide, false)
    }
  },
  destroyed () {
    this.tooltip = undefined
    this.$el.removeEventListener('mouseover', this.show)
    this.$el.removeEventListener('mouseout', this.hide)
  },
  watch: {
    text (value) {
      this.text = value
    }
  }
}
